import { render, staticRenderFns } from "./order-stat.vue?vue&type=template&id=00e1e6c1&scoped=true"
import script from "./order-stat.vue?vue&type=script&lang=js"
export * from "./order-stat.vue?vue&type=script&lang=js"
import style0 from "./order-stat.vue?vue&type=style&index=0&id=00e1e6c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e1e6c1",
  null
  
)

export default component.exports